import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { sendPasswordResetEmail } from 'firebase/auth';
import ShellHeader from '../components/ShellHeader';
import { auth } from '../firebase';

function ForgotPasswordPage({ authUser }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (authUser) {
      navigate('/admin', { replace: true });
    }
  }, [authUser, navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      setStatus('Please enter an email address.');
      return;
    }

    setLoading(true);

    try {
      await sendPasswordResetEmail(auth, trimmedEmail);
    } catch (resetError) {
      // Intentionally ignore errors so the response is the same for any email.
    } finally {
      setStatus('If an account exists for that email, a reset link has been sent.');
      setLoading(false);
    }
  };

  return (
    <div className="site-shell">
      <ShellHeader authUser={authUser} />
      <main className="auth-wrap">
        <section className="auth-card">
          <h1>Reset Password</h1>
          <p>Enter your email address and we will send reset instructions.</p>

          <form className="upload-form" onSubmit={handleSubmit}>
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="Email"
              required
            />
            <button type="submit" disabled={loading}>
              {loading ? 'Sending...' : 'Send Reset Email'}
            </button>
            <button type="button" onClick={() => navigate('/login')}>
              Back to Login
            </button>
          </form>

          {status && <p className="status-text">{status}</p>}
        </section>
      </main>
    </div>
  );
}

export default ForgotPasswordPage;
